import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class StealResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("StealResourcePackage");
    }
    public get assets_views_steal_popup_steal_popup_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/steal_popup/steal_popup-0_1x.atlas.json");
    }
    public get assets_views_steal_popup_girl_body_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["girl_body.png"];
    }
    public get assets_views_steal_popup_coins_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["coins.png"];
    }
    public get assets_views_steal_popup_card_bg_light_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["card_bg_light.png"];
    }
    public get assets_views_steal_popup_card_back_side_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["card_back_side.png"];
    }
    public get assets_views_steal_popup_card_bg_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["card_bg.png"];
    }
    public get assets_views_steal_popup_forearm_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["forearm.png"];
    }
    public get assets_views_steal_popup_wrist_flashlight_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["wrist_flashlight.png"];
    }
    public get assets_views_steal_popup_profile_icon_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["profile_icon.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0065_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0065.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0066_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0066.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0067_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0067.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0068_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0068.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0069_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0069.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0070_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0070.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0071_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0071.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0072_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0072.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0073_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0073.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0074_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0074.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0242_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0242.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0243_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0243.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0244_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0244.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0245_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0245.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0246_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0246.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0247_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0247.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0248_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0248.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0249_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0249.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0250_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0250.png"];
    }
    public get assets_views_steal_popup_avatars_profile_icons_0251_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_0_1x_atlas_json.textures["avatars/profile_icons_0251.png"];
    }
    public get assets_views_steal_popup_steal_popup_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/steal_popup/steal_popup-0_1x.atlas.png");
    }
    public get assets_views_steal_popup_steal_popup_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/steal_popup/steal_popup-1_1x.atlas.json");
    }
    public get assets_views_steal_popup_light_bg_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_1_1x_atlas_json.textures["light_bg.png"];
    }
    public get assets_views_steal_popup_light_2_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_1_1x_atlas_json.textures["light_2.png"];
    }
    public get assets_views_steal_popup_light_1_png(): Texture {
        return this.assets_views_steal_popup_steal_popup_1_1x_atlas_json.textures["light_1.png"];
    }
    public get assets_views_steal_popup_steal_popup_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/steal_popup/steal_popup-1_1x.atlas.png");
    }
}

